import React, { useState, useEffect } from "react";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import CreateContact from "./CreateContact";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from "@material-ui/icons/Edit";
import Grid from "@material-ui/core/Grid";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Typography, Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import UseFetchData from "../../../hooks/UseFetchData";


const AccountDtls = ({ AccountID, AccountMainData }) => {
  const classes = useStyles();
  const [isOpen, setOpen] = useState(false);
  const [ContactID, setContactID] = useState('')
  const [AccountName, setAccountName] = useState('')

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [CreatedBy, setCreatedBy] = useState("");
  const [CreatedOn, setCreatedOn] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");
  const [ModifiedOn, setModifiedOn] = useState("");
  const [Cresponse, CfetchData] = UseFetchData();

  const OpenModal = () => {
    setOpen(true);
    setContactID('');
  };


  useEffect(() => {
    if (AccountMainData !== undefined && AccountMainData.length > 0) {
      setAccountName(AccountMainData[0].AccountName);
      setCreatedBy(AccountMainData[0].CreatedBy);
      setCreatedOn(AccountMainData[0].CreatedOn);
      setModifiedBy(AccountMainData[0].ModifiedBy);
      setModifiedOn(AccountMainData[0].ModifiedOn);
      PopulateData();

    }
  }, [AccountMainData]);

  const PopulateData = () => {
    var bodyFormData = new FormData();
    bodyFormData.append("AccountID", AccountID);
    CfetchData("Contact/List", bodyFormData);
  }

  const openModal = (row) => {
    // debugger;
    setOpen(true);
    setContactID(row.id);
  }

  useEffect(
    () => {
      const gridCols = [
        {
          field: "id",
          headerName: ".",
          renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params); }} ><EditIcon fontSize={"small"}></EditIcon></a> </strong>),
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 70,
        },
        {
          field: "Salutation",
          headerName: "Salutation",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 150,
        },
        {
          field: "ContactName",
          headerName: "Contact Name",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        // {
        //   field: "AccountName",
        //   headerName: "Account",
        //   headerClassName: "super-app-theme--header",
        //   headerAlign: "center",
        //   width: 180,
        // },
        {
          field: "Designation",
          headerName: "Designation",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
        },
        {
          field: "Department",
          headerName: "Department",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
        },
        {
          field: "Mobile",
          headerName: "Mobile",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 180,
        },
        {
          field: "Phone",
          headerName: "Phone",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "Email",
          headerName: "Email",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "Address1",
          headerName: "Address1",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        // {
        //   field: "Address2",
        //   headerName: "Address2",
        //   headerClassName: "super-app-theme--header",
        //   headerAlign: "center",
        //   width: 200,
        // },
        {
          field: "City",
          headerName: "City",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "Country",
          headerName: "Country",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        {
          field: "State",
          headerName: "State",
          headerClassName: "super-app-theme--header",
          headerAlign: "center",
          width: 200,
        },
        // {
        //   field: "PINCode",
        //   headerName: "PIN Code",
        //   headerClassName: "super-app-theme--header",
        //   headerAlign: "center",
        //   width: 200,
        // },

      ];
      setColumns(gridCols);
      setRows(Cresponse);
    }, [Cresponse]);


  return (
    <Paper style={{ paddingLeft: 10, paddingRight: 10 }}>
      <div
        style={{
          textDecoration: "underline",
          textDecorationColor: "#0096FF",
          textDecorationThickness: 5,
          fontSize: 20,
          fontWeight: "bold",
          marginTop: 5,
        }}
      >
        DETAILS
      </div>
      <Typography className={classes.headerCmn} style={{ marginLeft: 0 }} noWrap>
        Contact Details
        <div style={{ width: "100%" }}>
          <div style={{ float: "right" }}>
            <BiztranControls.Button
              text="Add New"
              style={{ margin: "0.2rem", height: "1.6rem" }}
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                OpenModal();
              }}
            />
          </div>
        </div>
      </Typography>

      <Grid spacing={1} container style={{ marginTop: 7, paddingRight: 5, paddingLeft: 5 }}>
        <BiztranControls.DataGrid
          rowHeight={25}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          Height="490px"
          //autoHeight={true}
          Width="100%"
        />
        <ModalFrame
          title="Contact Details"
          maxWidth="md"
          isOpen={isOpen}
          headerAlign="center"
          setOpen={setOpen}
        >
          <CreateContact
            ContactID={ContactID}
            AccountID={AccountID}
            AccountName={AccountName}
            setOpen={setOpen}
            PopulateData={PopulateData}
          />
        </ModalFrame>

        <Grid item xs={12} ></Grid>
        <Grid item xs={12} className={classes.headerCmn}>
          System Information
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Created By:</div>
          <div>{CreatedBy}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Last Modified By:</div>
          <div>{ModifiedBy}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Created On:</div>
          <div>{CreatedOn}</div>
        </Grid>
        <Grid item xs={6} container direction="row">
          <div style={{ width: 120 }}>Modified On:</div>
          <div>{ModifiedOn}</div>
        </Grid>
      </Grid>
    </Paper>
  );
};

const useStyles = makeStyles((theme) => ({
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.1rem",
    fontWeight: "bold",
  },
}));

export default AccountDtls;
